import { IAutomationObject } from '../../types'

export interface IEdgeDevice extends IAutomationObject {
    modelId: string;
    noConnection: boolean;
}

export const schema = 'AutomationApps.Devices.EdgeDevice';
export const modelId = 'dtmi:AutomationApps:Devices:EdgeDevice';


